<template>
  <v-input
    ref="input"
    dense
    hide-details="auto"
    :class="css"
    v-bind="$attrs"
    v-on="$listeners"
    :input="'input'"
  >
    <slot></slot>
  </v-input>
</template>

<script>
export default {
  props: {
    css: {
      type: [String, Object],
      default: "flex-grow-0 mr-1",
    },
  },
  methods: {
    validate() {
      this.$refs.input.validate();
    },
  },
};
</script>
